import React from 'react';
import PropTypes from 'prop-types';

const YesNo = ({ data }) => {
  let displayText = "Nei";
  if (data === true)
  {
    displayText = "Já";
  }
  return (
    <span>{displayText}</span>
  );
};

YesNo.propTypes = {
  data: PropTypes.bool,
};

export default YesNo;



// WEBPACK FOOTER //
// ./src/components/Display/YesNo.js